import { APP_NAME, $document } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'FormWasteZone';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`,
    INPUT: `input.${EVENT_NAMESPACE}`,
    SUBMIT: `submit.${EVENT_NAMESPACE}`,
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // UI
        this.$form   = $('[data-form]', this.$el);
        this.$input  = $('[data-input]', this.$el);
        this.$list   = $('[data-list]', this.$el);

        // Data
        this.selectedAddress = null;
        this.selectedUrl = null;
        this.debounceTimer = null;

        // Binding
        this.onInput = this.onInput.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    // ----------------------------------------------------------
    // Lifecycle
    // ----------------------------------------------------------

    init() {
        this.$input.on(EVENT.INPUT, this.onInput);
        this.$form.on(EVENT.SUBMIT, this.onSubmit);
        this.$list.on(EVENT.CLICK, this.onClick);
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }

    // ----------------------------------------------------------
    // Callbacks
    // ----------------------------------------------------------
    onInput(e) {
        const query = e.target.value;

        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(async () => {
            if (query.length < 3) return;

            this.$list[0].innerHTML = '';

            const suggestions = await this.fetchAutocomplete(query);

            if (suggestions.length > 0) {
                this.$el.addClass('has-list-visible');
            } else {
                this.$el.removeClass('has-list-visible');
                return;
            }

            suggestions.forEach((s) => {
                const li = document.createElement('li');
                li.textContent = s.full_address + ' (' + s.zone.name + ')';
                li.dataset.id = s.id;
                li.dataset.zone = s.zone.id;
                li.dataset.url = s.zone.url;
                this.$list[0].appendChild(li);
            });
        }, 300);
    }

    onClick(e) {
        const target = e.target
        if (!target) return;

        this.$input[0].value = target.textContent;

        this.selectedAddress = {
            id: target.dataset.id,
            zone: {
                id: target.dataset.zone,
                url: target.dataset.url
            }
        };

        this.$el.removeClass('has-list-visible');
        this.$el.addClass('has-selected-address');

        this.$list[0].innerHTML = '';
        this.$input[0].blur();
    }

    async onSubmit(e) {
        e.preventDefault();
        if (!this.selectedAddress) return alert("Veuillez sélectionner une adresse.");

        const url = location.origin + this.selectedAddress.zone.url;
        if (!url) return alert("Une erreur s'est produite. Veuillez réessayer.");

        $document.triggerHandler({
            type: 'goTo.Load',
            href: url,
        });
    }

    // ----------------------------------------------------------
    // Methods
    // ----------------------------------------------------------
    async fetchAutocomplete(query) {
        const res = await fetch(`/api/autocomplete-addresses?q=${encodeURIComponent(query)}`)
        return await res.json(); // Expected to return [{ id, full_address }, ...]
    }
}
